import styled from 'styled-components';
import { breakpoints, colors } from '@oxygen/theme';
import { ChevronRight, ChevronLeft } from '@styled-icons/material';

export const PageNumber = styled.a`
  color: ${(props) => (props.active ? colors.storm2 : colors.storm5)};
  line-height: 21px;
  padding: 8px;
  cursor: pointer;
  text-decoration: none;
`;
export const PageNumbers = styled.div`
  display: flex;
  @media (max-width: ${breakpoints.small}) {
      display: none;
    }
  }
`;

export const MobilePageNumbersLabel = styled.div`
  display: none;
  @media (max-width: ${breakpoints.small}) {
      display: flex;
    }
  }
`;

export const Next = styled(ChevronRight)`
  width: 2rem;
  cursor: ${(props) => (props.active ? 'pointer' : 'default')};
  margin: 0 8px;
  color: ${(props) => (props.active ? colors.storm2 : colors.storm8)};
`;

export const Previous = styled(ChevronLeft)`
  width: 2rem;
  cursor: ${(props) => (props.active ? 'pointer' : 'default')};
  margin: 0 8px;
  color: ${(props) => (props.active ? colors.storm2 : colors.storm8)};
`;

export const GapIndicator = styled.div`
  :before {
    content: '...';
    cursor: initial;
  }
`;
